import { useCallback } from 'react';

import { StatusCell, TagColor } from '@equip.health/ui';

import { InsuranceReviewStatusOptions } from '~/lib/constants/inquiry.constants';

interface InsuranceReviewStatusCellProps {
  coverageStatus: string;
  coverageStatusOptions: CoverageStatusOptionsProps[];
  id: string;
  inquiryId: string;
  updateInsuranceReviewStatus?: (
    inquiryId: string,
    selectedStatus: string,
    version: string,
  ) => void;
  version: string;
}

const InsuranceReviewStatusCell = ({
  coverageStatus,
  coverageStatusOptions,
  id,
  inquiryId,
  updateInsuranceReviewStatus,
  version,
}: InsuranceReviewStatusCellProps) => {
  const updateInsuranceReview = useCallback(
    (optionId) => {
      const selectedStatus = coverageStatusOptions?.find(
        (option) => option.id === optionId,
      )?.value;

      if (selectedStatus === coverageStatus) {
        return;
      }

      updateInsuranceReviewStatus?.(inquiryId, selectedStatus, version);
    },
    [
      updateInsuranceReviewStatus,
      coverageStatusOptions,
      coverageStatus,
      inquiryId,
      version,
    ],
  );

  return (
    <StatusCell
      id={`inquiry-review-status-cell__${id}`}
      onOptionClick={updateInsuranceReview}
      status={coverageStatus ?? InsuranceReviewStatusOptions.NOT_READY}
      statusOptions={coverageStatusOptions.map((option) => ({
        color: option.color as TagColor,
        id: option.id,
        value: option.value,
      }))}
    />
  );
};

export default InsuranceReviewStatusCell;
